import * as React from "react";
const SvgSystemBoard = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 2v20.117h18V2H8.689Zm1.633 1.66h14.722v16.797H4.633v-9.5z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } }),
    React.createElement("path", { d: "M11 9V10.453H9.453V12H8v1H9.453v2.002H8V16H9.453V17.547H11V19h1V17.547h2.002V19H15V17.547H16.547V16H18v-.998H16.547V13H18v-1H16.547V10.453H15V9h-.998V10.453H12V9h-.363zm0 3h4v4h-4v-2z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgSystemBoard;
